export default {"src":"/_next/static/media/header_not_available.9852afbe.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};